import { render, staticRenderFns } from "./DiskBackup.vue?vue&type=template&id=0bfc704b"
import script from "./DiskBackup.vue?vue&type=script&lang=js"
export * from "./DiskBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports